import { render, staticRenderFns } from "./VerifyAccountView.vue?vue&type=template&id=9ec5f358&scoped=true&"
import script from "./VerifyAccountView.vue?vue&type=script&lang=js&"
export * from "./VerifyAccountView.vue?vue&type=script&lang=js&"
import style0 from "./VerifyAccountView.vue?vue&type=style&index=0&id=9ec5f358&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ec5f358",
  null
  
)

export default component.exports